import { useEffect, useState } from "react";
import { internalApi } from "../../api/internal";
import api from "../../auth/api"; // ajusta

export default function TasksPanel({ threadId, canManage }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [users, setUsers] = useState([]);

  async function load() {
    setLoading(true);
    try {
      const { data } = await internalApi.listTasks(threadId);
      setRows(data?.rows || []);
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo cargar tareas");
    } finally {
      setLoading(false);
    }
  }

  async function loadUsers() {
    try {
      const { data } = await api.get("/users", { params: { active: 1 } });
      setUsers(data?.rows || data?.users || []);
    } catch {
      setUsers([]);
    }
  }

  useEffect(() => {
    if (!threadId) return;
    load();
    loadUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [threadId]);

  const add = async () => {
    const t = title.trim();
    if (!t) return;
    try {
      await internalApi.createTask(threadId, {
        title: t,
        assigned_to: assignedTo ? Number(assignedTo) : null,
      });
      setTitle("");
      setAssignedTo("");
      load();
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo crear tarea");
    }
  };

  const patch = async (taskId, payload) => {
    try {
      await internalApi.patchTask(taskId, payload);
      load();
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo actualizar");
    }
  };

  const del = async (taskId) => {
    if (!window.confirm("¿Eliminar tarea?")) return;
    try {
      await internalApi.deleteTask(taskId);
      load();
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo eliminar");
    }
  };

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-2">
        <div className="font-semibold">Tareas</div>
        <button className="px-3 py-1.5 rounded-lg border text-sm" onClick={load}>
          Refrescar
        </button>
      </div>

      <div className="bg-slate-50 border border-slate-200 rounded-xl p-3 mb-3">
        <div className="text-sm font-semibold mb-2">Nueva tarea</div>
        <input
          className="w-full px-3 py-2 rounded-lg border bg-white text-sm mb-2"
          placeholder="Título…"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") add();
          }}
        />
        <div className="flex items-center gap-2">
          <select
            className="flex-1 px-3 py-2 rounded-lg border bg-white text-sm"
            value={assignedTo}
            onChange={(e) => setAssignedTo(e.target.value)}
          >
            <option value="">Sin asignar</option>
            {users.map((u) => (
              <option key={u.id} value={u.id}>{u.name}</option>
            ))}
          </select>
          <button className="px-3 py-2 rounded-lg bg-slate-900 text-white text-sm" onClick={add}>
            Agregar
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-slate-500">Cargando…</div>
      ) : !rows.length ? (
        <div className="text-slate-500">No hay tareas.</div>
      ) : (
        <div className="space-y-2">
          {rows.map((t) => (
            <div key={t.id} className="border border-slate-200 rounded-xl p-3">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-semibold truncate">{t.title}</div>
                  <div className="text-xs text-slate-500">
                    Asignado: {t.assigned_name || "—"} · Estado: {t.status}
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <select
                    className="px-2 py-1 rounded border bg-white text-sm"
                    value={t.status}
                    onChange={(e) => patch(t.id, { status: e.target.value })}
                  >
                    <option value="todo">todo</option>
                    <option value="doing">doing</option>
                    <option value="done">done</option>
                    <option value="canceled">canceled</option>
                  </select>

                  {canManage ? (
                    <button className="px-2 py-1 rounded border text-sm" onClick={() => del(t.id)}>
                      Eliminar
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
